import { render, staticRenderFns } from "./user-checkbox.vue?vue&type=template&id=5d457768&lang=pug"
import script from "./user-checkbox.vue?vue&type=script&lang=js"
export * from "./user-checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports